import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Logo from '../Logo/Logo'
import AccessDeniedIllustration from '../../Assets/Illustrations/AccessDeniedIllustration'
import useWindowSize from '../../hooks/useWindowSize'
import { useStyles } from './AccessDeniedStyles'

function AccessDenied({ reason }) {
  const windowSize = useWindowSize()
  const classes = useStyles()

  useEffect(() => {
    window?.gtag('event', 'quiz_load_failed', {
      event_category: 'Access denied',
      event_label: 'Access denied',
    })
  }, [])

  return (
    <Grid
      container
      data-testid="test-access-denied"
      direction="column"
      className={classes.root}
      style={{ height: `${windowSize?.height}px` }}
    >
      <Helmet>
        <title>Access denied</title>
      </Helmet>
      <Grid container alignItems="center" className={classes.header}>
        <Logo />
      </Grid>
      <Grid container alignItems="center" className={classes.body}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          className={classes.illustrationAndTextWrapper}
        >
          <Grid item className={classes.illustrationWrapper}>
            <AccessDeniedIllustration />
          </Grid>
          <Grid item className={classes.textWrapper}>
            <Typography data-testid="test-reason" className={classes.text}>
              {reason}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default AccessDenied
